import { BaseWboPersistenceProvider } from '@webcat/wbo-client';

declare const window: any;

export default class WboLocalFilesystemPersistenceProvider extends BaseWboPersistenceProvider {
    private readonly electronAPI = window.electronAPI;

    constructor(boardName: string, username: string) {
        super(boardName, username)
    }

    async saveDataToStorage(fileName : string, data : any): Promise<void>{
        await window.electronAPI.saveWboFile(fileName, data)
    }
    async readDataFromStorage(fileName : string): Promise<any>{
        return await this.electronAPI.getWboFile(fileName);
    }
    async deleteFromStorage(fileName : string): Promise<void>{
        await window.electronAPI.deleteWboFile(fileName);
    }
}
